import EmailIcon from '@mui/icons-material/Email'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Box, Button, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import style from './style'
import Section from '../../components/Section'

const Contact = () => {
  const intl = useIntl()

  return (
    <Box sx={style.container}>
      <Box sx={style.titleContainer}>
        <Typography variant="h1" fontSize={48} color="secondary">
          <FormattedMessage id="Contact.Title" defaultMessage="Contact" />
        </Typography>
      </Box>

      <Section
        title={intl.formatMessage({ id: 'Common.ContactUs', defaultMessage: 'Contact us' })}
        imgSrc="/images/contact.png"
      >
        <div>
          <FormattedMessage
            id="Contact.Description"
            defaultMessage="If you want to know more about QuantumBio Vins, or if you wish to order some wines, please reach out to us to get our wine list:"
          />
        </div>

        <Box sx={style.actionsContainer}>
          <Button
            href="mailto:juliette@quantumbioconsulting.ch"
            startIcon={<EmailIcon />}
            variant="contained"
            sx={style.emailButton}
          >
            <FormattedMessage id="Contact.Email" defaultMessage="Send us an email" />
          </Button>

          <Button
            href="https://wa.me/41786040193"
            target="_blank"
            startIcon={<WhatsAppIcon />}
            variant="contained"
            sx={style.whatsAppButton}
          >
            <FormattedMessage id="Contact.WhatsApp" defaultMessage="Chat on WhatsApp" />
          </Button>
        </Box>
      </Section>
    </Box>
  )
}

export default Contact
